// ============================================
// 表单校验工具
// ============================================

export interface ValidationError {
  field: string;
  message: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
}

export function validatePhone(phone: string): boolean {
  const phoneRegex = /^(\+61|0)[2-4789]\d{8}$/;
  return phoneRegex.test(phone);
}

export function formatPhoneToInternational(phone: string): string {
  if (phone.startsWith('+61')) return phone;
  if (phone.startsWith('0')) {
    return '+61' + phone.substring(1);
  }
  return phone;
}

export function validateSOSForm(data: { event_type?: string }): ValidationResult {
  const errors: ValidationError[] = [];

  if (!data.event_type || data.event_type.trim() === '') {
    errors.push({ field: 'event_type', message: 'Event type is required' });
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}
